import { extractId } from '../../../util/shared/vue-global';

export const glLockUnlockOperations = () => ({
  lockByDateAndFy: 'lockByDateAndFy',
  unlockByIds: 'unlockByIds',
  lockByIds: 'lockByIds',
});

export const glTaggedTransactionEnums = () => [
  'TOTAL_PAID_WARRANT',
  'TOTAL_BANK_CASH_CHECK',
  'TOTAL_BANK_MISC_MTG_CASH_CHECK',
  'TOTAL_MTG_CASH_CHECK',
  'TOTAL_MISC_CASH_CHECK',
];

/**
 * A GL row can carry a fund doc from another fiscal year, which is missing from the fund list the
 * dialog loads for its year. Returns a select option for that fund - its number instead of a
 * blank select - or null when the row's fund is in the list or there is nothing to compare with.
 */
export const buildStaleFundOption = (fund, fundList) => {
  const fundId = extractId(fund);
  if (!fundId || !fundList || fundList.length === 0 || fundList.some((f) => f._id === fundId)) {
    return null;
  }
  const fundObj = typeof fund === 'object' && fund !== null ? fund : {};
  const fundNumber = fundObj.fund || '';
  const description = fundObj.description ? ` - ${fundObj.description}` : '';
  return {
    _id: fundId,
    fund: fundNumber,
    fundDesc: `${fundNumber || 'Unknown fund'}${description} (other fiscal year)`,
  };
};

export default {};
